import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  Table,
  Panel,
  PanelGroup,
  Form,
  Message,
  IconButton,
  Icon,
  Uploader,
  Modal,
  Button,
} from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import ReportResultProjectForm from './ReportResultProjectForm'
import ReportResultView from './ReportResultView'
import ButtonPanel from '../../ButtonPanel'
import {
  getMonitoring,
  saveReportmethodology,
  updateReportmethodology,
  deleteReportmethodology,
} from '../../../redux/actions/monitoring'

export default function ReportResultProjectWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [viewTableData, setViewTableData] = useState(_schema.tableView)
  const [valueOnEdit, setValueOnEdit] = useState()
  const [valueOnDelete, setValueOnDelete] = useState()
  const [isdelete, setIsdelete] = useState(false)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  // useEffect(() => {
  //   // setIsEdit(isEdit)
  //   setIsError(false)
  // }, [isEdit])

  const onSubmit = (data) => {
    console.log('data onSubmit', data)

    let request = {
      id: valueOnEdit?.id || null,
      projectVersionId: projectId,
      userId: '0',
      resultOption: data.resultOption,
      indicator: data.indicatorsOption,
      dataCollection: data.dataCollection,
      dataCollectionMethod: data.dataCollectionMethod,
    }

    handleCallService(projectId, request)
  }

  const handleCallService = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      let response

      if (valueOnEdit?.id) {
        console.log('call update.')
        response = await updateReportmethodology(id, request)
      } else {
        console.log('call save.')
        response = await saveReportmethodology(id, request)
      }

      if (response) {
        setFormSchema(response?.forms?.monitoring?.reportResultProject)
        onChangeIsEdit(false)
      } else {
        setIsError(true)
      }
      setValueOnEdit(null)
    } catch (error) {
      console.log('error ', error)
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handeleEdit = (rowData, index) => {
    console.log('handeleEdit ', rowData, index)

    setValueOnEdit(rowData)
    setIsError(false)
    onChangeIsEdit(!isEdit)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const handeleDelete = async (rowData, index) => {
    console.log('handeleDelete ', rowData, index)
    setValueOnDelete(rowData)
    setIsdelete(true)
  }

  const handeleConfDelete = async () => {
    console.log('handeleConfDelete ', valueOnDelete)
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      console.log('call delete.')
      const request = {
        id: valueOnDelete.id,
        projectVersionId: projectId,
        userId: '0',
        projectIndicatorId: valueOnDelete.indicatorId,
        projectOutComeId: valueOnDelete.resultId,
      }
      const response = await deleteReportmethodology(projectId, request)

      if (response) {
        setFormSchema(response?.forms?.monitoring?.reportResultProject)
        setValueOnDelete(null)
        setIsdelete(false)
      } else {
        setIsError(true)
      }
    } catch (error) {
      console.log(error)
    }

    setIsLoading(false)
    doneLoading()
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        <ReportResultProjectForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          // handelPreview={onSubmit}
          valueOnEdit={valueOnEdit}
        />
      ) : (
        <>
          <div>
            {/* {formSchema.id == null && <div>-ไม่ระบุ-</div>} */}
            <ReportResultView
              schema={formSchema.tableView}
              onEdit={handeleEdit}
              onDelete={handeleDelete}
            />
          </div>
        </>
      )}

      <Modal
        backdrop="static"
        size="xs"
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
          setIsDeleteFail(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {isdelete && (
            <div
              dangerouslySetInnerHTML={{
                __html: ` <b>ผลลัพธ์</b> ${valueOnDelete.result} <br /> <b>ตัวชี้วัด</b> ${valueOnDelete.indicators} `,
              }}
            />
          )}
          {/* {isDeleteFail && (
            <Message
              showIcon
              type="error"
              description={`ลบ ${schema.buttonText ? schema.buttonText : ''} ไม่สำเร็จ`}
            />
          )} */}
        </Modal.Body>
        <Modal.Footer>
          {isdelete && (
            <>
              <Button
                onClick={(e) => {
                  // onDelete(selectedIndex)
                  handeleConfDelete()

                  // setIsDeleteFail(false)
                }}
                appearance="primary"
              >
                ลบ
              </Button>
              <Button
                onClick={(e) => {
                  setValueOnDelete(null)
                  setIsdelete(false)
                }}
                appearance="subtle"
              >
                ยกเลิก
              </Button>
            </>
          )}

          {/* {isDeleteFail && (
            <Button
              onClick={(e) => {
                setIsDeleteFail(false)
                setIsdelete(false)
                setSelectedIndex(-1)
              }}
              appearance="subtle"
            >
              ปิด
            </Button>
          )} */}
        </Modal.Footer>
      </Modal>

      {showCommandButton && (
        <>
          <hr />
          {isEdit ? (
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={'บันทึกการแก้ไข'}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setValueOnEdit()
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          ) : (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
            >
              {'แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </IconButton>
          )}
        </>
      )}
    </Panel>
  )
}
